import React from "react";
import moment from "moment";
import { OverlayTrigger, Tooltip, Popover } from "react-bootstrap";
import { lovLabel, lovValue } from "core/form/formUtils";
import { formatDateTime, formatInterval, isValid } from "core/common/utils/dateUtils";
import "core/event/component/historyBlocks.less";
import { EVENTCATEGORY_MAP
} from "core/event/eventDomain";
import * as icons from "core/components/buttons/svgIcons";
import { loc } from "core/common/config/locales";
import { LovItem } from "core/metamodel/mdEntity";
import { BrimMessage, ImportEntryBrimMessage } from "core/dataimport/dataImportDomain";
import { ProductVehicle, Vehicle } from "product/productDomain";
import { Link } from "react-router";
import { addTenantToQuery } from "core/common/utils/utils";




/* **************************************************************************************
 *******     BrimMessageFielTable     *******************************************************
 ****************************************************************************************/

function getProdutMatch(produtVehicle: ProductVehicle[], product: LovItem): ProductVehicle[] {
  return produtVehicle.filter((producVehicle) => producVehicle.product.value === product.value);
};

function sortedProductsVehicles(productVehicles: ProductVehicle[], product: LovItem): ProductVehicle[] {
  return productVehicles.sort((productVehicle) => {
    if (productVehicle.product.value === product.value) return -1;
    if (productVehicle.product.value === product.value) return 1;
    return 0;
  }
  )
};

const FutureProductVehicleTable = ({ brimMessage, productMatch, futureProductVehicle }: { brimMessage: BrimMessage, productMatch: ProductVehicle[], futureProductVehicle: ProductVehicle }) => {
  const boldProduct = (productMatch.length) ? "bold-product" : "";

  let price = (futureProductVehicle.validPrice.price != null) ? futureProductVehicle.validPrice.price : "";
  let currency = (futureProductVehicle.validPrice.currency != null) ? futureProductVehicle.validPrice.currency : "";

  return (
    <tbody>
      <tr>
        <th>{loc.i18n`Future product`}</th>
        <th>{loc.i18n`Valid price`}</th>
        <th>{loc.i18n`Start Date`}</th>
        <th>{loc.i18n`End Date`}</th>
        <th>{loc.i18n`Status`}</th>
        <th>{loc.i18n`Subscription`}</th>
      </tr>
      <tr key={1}>
        <td className={boldProduct}>{futureProductVehicle.product.label}</td>
        <td>{price} {currency}</td>
        <td>{futureProductVehicle.validFrom}</td>
        <td>{futureProductVehicle.validTo}</td>
        <td>{brimMessage.status.label}</td>
        <td>{brimMessage.subscriptionType}</td>
      </tr>

    </tbody>)

};

const BrimMessageProductVehicleTable = ({ vehicle, productMatch, product }: { vehicle: Vehicle, productMatch: ProductVehicle[], product: LovItem }) => {


  return (
    <tbody>
      <tr key={2}>
        <th>{loc.i18n`Active products`}</th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
      {sortedProductsVehicles(vehicle.productVehicles, product).map((productVehicle, index) => {
        const boldProduct = (productMatch.length && productMatch.includes(productVehicle)) ? "bold-product" : "";
        return (
          <tr key={index + 3}>
            <td className={boldProduct}>{productVehicle.product.label}</td>
            <td>{(productVehicle.validPrice) ? productVehicle.validPrice.price : ""} {(productVehicle.validPrice) ? productVehicle.validPrice.currency : ""}</td>
            <td>{productVehicle.validFrom}</td>
            <td>{productVehicle.validTo}</td>
            <td></td>
            <td></td>
          </tr>
        )
      })}
    </tbody>)
};

const BrimMessageValues = (brimMessage: BrimMessage): Map<string, string> => {
  
  return new Map([
    ["Product", brimMessage.productNumber + " " + brimMessage.productName],
    ["Product status", brimMessage.productStatus],
    ["Subscription status", brimMessage.subscriptionType],
    ["Customer CDB", brimMessage.customerPartyId],
    ["Vin", brimMessage.vin],
    ["Registration number", brimMessage.registrationNumber],
    ["Subscription id", brimMessage.subscriptionId],
    ["Subscription number", brimMessage.subscriptionNumber],
    ["Start Date", formatDateTime(brimMessage.startDate)],
    ["End Date", formatDateTime(brimMessage.endDate)],
  ]);
}

const BrimMessageTable = ({ brimMessage }: { brimMessage: BrimMessage }) => {

  return (
    <tbody>
      <tr>
        <th>{loc.i18n`Original product`}</th>
        <th>{loc.i18n`Value`}</th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
      {Array.from(BrimMessageValues(brimMessage)).filter(([key, value]) => value != null).map(([key, value]) => {
        return (
          <tr key={key}>
            <td>{key}</td>
            <td>{value}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        )
      })}</tbody>)
};



const PartyBlock = ({ party }) => (
  <div className="link-text"><Link activeClassName="link-text" to="partyDetail" params={{ id: lovValue(party) }} query={addTenantToQuery()}>{party.label}</Link></div>
)
const VehicleBlock = ({ vehicle }) => (
  <div className="link-text"><Link activeClassName="link-text" to="vehicleDetail" params={{ id: vehicle.vehicleId }} query={addTenantToQuery()}>{vehicle.registrationNumber} - {vehicle.vin}</Link></div>
)

export const BrimMessageBlock = ({ importEntryBrimMessage }: { importEntryBrimMessage: ImportEntryBrimMessage }) => {

  let EventCatIcon = icons[EVENTCATEGORY_MAP["DATA_EVENT"].icon];
  let brimMessage: BrimMessage = importEntryBrimMessage.brimMessage;
  let futureProductVehicle: ProductVehicle = importEntryBrimMessage.futureProductVehicle;
  const productMatch = (brimMessage.vehicle && brimMessage.vehicle.productVehicles.length && brimMessage.product) ? getProdutMatch(brimMessage.vehicle.productVehicles, brimMessage.product) : [];
  return (
    <div className="event-history">
      <div className="eh-header">
        <div className="eh-header-left">
          <EventCatIcon />
          <div className="text">{lovLabel(brimMessage.status)} - {formatDateTime(brimMessage.statusChangeDate)}</div>
        </div>
        <OverlayTrigger placement="bottom" delayShow={500} overlay={<Tooltip id={brimMessage.messageId + "_dateTooltip"}>{formatDateTime(brimMessage.dateCreated)}</Tooltip>}>
          <span>{brimMessage.userCreated}, {moment(brimMessage.dateCreated).fromNow()}</span>
        </OverlayTrigger>
      </div>
      <div className="eh-objects">
        {(brimMessage.party) ? <PartyBlock party={brimMessage.party} /> : null}
        {(brimMessage.vehicle) ? <VehicleBlock vehicle={brimMessage.vehicle} /> : null}
        <div className="description-text">{brimMessage.statusDescription}</div>

        <table className="zz-simple-table">
          {(futureProductVehicle) ? <FutureProductVehicleTable brimMessage={brimMessage} productMatch={productMatch} futureProductVehicle={futureProductVehicle} /> : null}

          {(futureProductVehicle && brimMessage.vehicle && brimMessage.vehicle.productVehicles.length && brimMessage.product) ?
            <BrimMessageProductVehicleTable vehicle={brimMessage.vehicle} productMatch={productMatch} product={brimMessage.product} />
            : null}

          <BrimMessageTable brimMessage={brimMessage} />
        </table>
      </div>
    </div>
  );
}
  ;




// WEBPACK FOOTER //
// ./src/core/dataimport/component/brimMessageExpandBlock.tsx